import {PLATFORM_BOTH, PLATFORM_MOBILE, PLATFORM_WEB} from "../../constants/commons";
import {
  TAB_ADDED, TAB_ADDITIVES, TAB_BRANDS,
  TAB_DEFAULT, TAB_FOCUSED,
  TAB_NOT_ADDED,
  TAB_PAGE,
  TAB_PRODUCTS, UI_TYPE_BRAND, UI_TYPE_FOCUSED, UI_TYPE_GROUP,UI_FOCUSED_TYPE_PAGE
} from "./constants";
import {UI_TYPE_PRODUCT} from "./constants";
import {capitalize} from "lodash/string";
import {Tag} from "../../components/table/Status";

export const getUiBreadCrumbFormat = (item) => {
  return item ?
    item.type === UI_TYPE_GROUP ? <>
        <Tag label="Group"/><span>{item.sections.map(u => getUiBreadCrumbFormat(u)).join(' + ')}</span></> :

      `${capitalize(item.type)?.replaceAll("_", " ")}
    ${item.sub_type ? ` > ${capitalize(item.sub_type)?.replaceAll("_", " ")}` : ''}
    ${item.value ? ` > ${item.value.substring(0, 6)}` : ''}
    `
    : '';
};

export const getFilteredDynamicData = (data, filter, selectedDataList = [], mobileData = true) => {

  const platformFilter = mobileData ? PLATFORM_MOBILE : PLATFORM_WEB;
  return filter === TAB_PRODUCTS ?
    data.filter((d) => d.type === UI_TYPE_PRODUCT && getDataFilterByPlatform(d, platformFilter))
    : filter === TAB_DEFAULT ?
      data.filter((d) => d.is_default && getDataFilterByPlatform(d, platformFilter))
      : filter === TAB_ADDITIVES ?
        data.filter((d) => !d.is_default && getDataFilterByPlatform(d, platformFilter))
        : filter === TAB_BRANDS ?
          data.filter((d) => d.type === UI_TYPE_BRAND && getDataFilterByPlatform(d, platformFilter))
          : filter === TAB_FOCUSED ?
            data.filter((d) => d.type === UI_TYPE_FOCUSED && getDataFilterByPlatform(d, platformFilter))
            : filter === TAB_ADDED ?
              data.filter((d) => selectedDataList.some((sel) => sel.section.id === d.id) && getDataFilterByPlatform(d, platformFilter))
              : filter === TAB_NOT_ADDED ?
                data.filter((d) => !selectedDataList.some((sel) => sel.section.id === d.id) && getDataFilterByPlatform(d, platformFilter))
                : filter === TAB_PAGE ?
                  data.filter((d) => d.type === UI_TYPE_FOCUSED && d.sub_type === UI_FOCUSED_TYPE_PAGE && getDataFilterByPlatform(d, platformFilter))
                    :data.filter((d) => getDataFilterByPlatform(d, platformFilter));
};

export const getDataFilterByPlatform = (data, filter) => data?.platform === filter || data.platform === PLATFORM_BOTH;
export const getSelectedDataFilterByPlatform = (data, filter) => data?.section?.platform === filter || data?.section?.platform === PLATFORM_BOTH;
export const getSelectedDataByPlatform = (data, filter) => data.filter((datum) => getSelectedDataFilterByPlatform(datum, filter));

export const isMobilePlatform = (platform, both = false) => platform === PLATFORM_MOBILE || (both && platform === PLATFORM_BOTH);
export const isWebPlatform = (platform, both = false) => platform === PLATFORM_WEB || (both && platform === PLATFORM_BOTH);
export const isAllPlatform = (platform) => platform === PLATFORM_BOTH;

export const hasTheGivenPlatform = (isMobile, itemList) =>
  itemList.some((it) => it.section.platform === (isMobile ? PLATFORM_MOBILE : PLATFORM_WEB) || it.section.platform === PLATFORM_BOTH);
// (!mobileView && !selectedItems.slice(0, pos).some((it)=>it.section.platform === PLATFORM_WEB || it.section.platform === PLATFORM_BOTH))}
